import type { ReactNode } from 'react';
import {
  MessageBoxProvider,
  useMessageBox,
} from './MessageBoxContext';
import type { MessageBoxOptions } from './MessageBoxOptions';
import type { MessageBoxTone } from '../components/ui/MessageBoxTone';

/** @deprecated Preferir MessageBoxOptions. */
export type ConfirmDialogOptions = MessageBoxOptions;

/** @deprecated Preferir MessageBoxTone. */
export type ConfirmDialogTone = MessageBoxTone;

type ConfirmDialogContextValue = {
  confirm: (options: MessageBoxOptions | string) => Promise<boolean>;
};

/** @deprecated Preferir MessageBoxProvider. */
export function ConfirmDialogProvider({ children }: { children: ReactNode }) {
  return <MessageBoxProvider>{children}</MessageBoxProvider>;
}

/** @deprecated Preferir useMessageBox. */
export function useConfirmDialog(): ConfirmDialogContextValue {
  const { confirm } = useMessageBox();
  return { confirm };
}
